import { camelCase } from 'es-toolkit';
import { Table } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';
import useBooleanConfig from '../../hooks/useBooleanConfig';
import { TABLE_COLUMNS, TABLE_COLUMNS_V2 } from '.';

export const DEFAULT_LEADS_PER_PAGE = 10;

const SkeletonCell = () => (
  <SkeletonContainer>
    <Bone css={{ marginBlock: 'tight' }} />
  </SkeletonContainer>
);

const SkeletonRow = ({ cellCount }: { cellCount: number }) => (
  <Table.Row>
    {Array.from({ length: cellCount }, (_, index) => (
      <Table.Cell key={index}>
        <SkeletonCell />
      </Table.Cell>
    ))}
  </Table.Row>
);

type LeadManagementTableSkeletonProps = {
  numberOfRows?: number;
  showHeader?: boolean;
};

export default function LeadManagementTableSkeleton({
  numberOfRows,
  showHeader = true,
}: LeadManagementTableSkeletonProps) {
  const enableLeadManagementV2 = useBooleanConfig('enableLeadManagementV2', false);
  const columns = enableLeadManagementV2 ? TABLE_COLUMNS_V2 : TABLE_COLUMNS;
  const SKELETON_ROWS = Array(numberOfRows || DEFAULT_LEADS_PER_PAGE).fill('');

  return (
    <Table.Root aria-label="Leads" appearance="horizontal" size="lg">
      {showHeader && (
        <Table.Header>
          <Table.Row>
            {columns.map((name) => {
              const colId = camelCase(name);
              return (
                <Table.HeaderCell key={colId} css={{ paddingLeft: name === 'Name' ? '75px' : '' }}>
                  {name}
                </Table.HeaderCell>
              );
            })}
          </Table.Row>
        </Table.Header>
      )}

      <Table.Body>
        {SKELETON_ROWS.map((_, index) => (
          <SkeletonRow key={index} cellCount={columns.length} />
        ))}
      </Table.Body>
    </Table.Root>
  );
}
